const names = document.querySelectorAll('.reviews__name');
for(let vales of names)
console.log(vales);

const titles = document.querySelectorAll('.reviews__titles');
titles.textContent = names;
